import { Col, Label, Row } from "reactstrap";
import React from "react";

export function TabStepBBusinessContactInformation({
  customerDetails,
  setCustomerDetails,
  handleRemoveEmailRow,
  handleAddEmailRow,
  handleRemovePhoneRow,
  handleAddPhoneRow,
  toggleVerticalTab,
  activeVerticalTab,
  handleCheckEachStep,
}) {
  return (
    <div id={"zdiv_customer_create_step_b_01"}>
      <div>
        <h5>Contact Information</h5>
      </div>

      <div>
        <Row className="g-3">
          <Col lg={8}>
            <div>
              <div>
                <span className={"h6"}>Email Address</span>
              </div>
              <div className={"d-flex flex-column w-100"}>
                {customerDetails.contactemailaddress_data?.map(
                  (email, index) => {
                    return (
                      <div key={index} className={"d-flex flex-column p-2"}>
                        <div className={"d-flex flex-row"}>
                          <input
                            type="text"
                            className={"form-control"}
                            value={email.EmailAddress}
                            onChange={(e) => {
                              setCustomerDetails((prevState) => {
                                const newState = {
                                  ...prevState,
                                };
                                newState.contactemailaddress_data[
                                  index
                                ].EmailAddress = e.target.value;

                                return newState;
                              });
                            }}
                          />{" "}
                          {customerDetails.contactemailaddress_data.length >
                            1 && (
                            <span
                              onClick={() => {
                                handleRemoveEmailRow(
                                  email.ContactEmailAddress_Id
                                );
                              }}
                              className={"ms-1 btn btn-soft-danger"}
                            >
                              <i className={" fa-solid fa-minus"}></i>
                            </span>
                          )}
                        </div>

                        <div>
                          <Label>Send invoices to contact</Label>
                        </div>
                        <div>
                          <span className={"fw-bold"}>Invoicing</span>
                        </div>
                        <div
                          className={
                            "d-flex flex-row justify-content-start align-items-center pt-1"
                          }
                        >
                          <div>
                            <div
                              className={
                                "ms-1  d-flex p-2 justify-content-center align-items-center   "
                              }
                            >
                              <span className={"p-0 m-0 me-1"}>
                                Primary Contact To:{""}
                              </span>
                              <input
                                type={"checkbox"}
                                checked={email.FlagEmailInvoiceTo === "1"}
                                onChange={(e) => {
                                  setCustomerDetails((prevState) => {
                                    const newState = {
                                      ...prevState,
                                    };
                                    newState.contactemailaddress_data[
                                      index
                                    ].FlagEmailInvoiceTo =
                                      e.target.checked === true ? "1" : "0";
                                    newState.contactemailaddress_data[
                                      index
                                    ].FlagEmailProformaInvoiceTo =
                                      e.target.checked === true && "1";

                                    return newState;
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div
                            className={
                              "ms-1   d-flex p-2 justify-content-center align-items-center   "
                            }
                          >
                            <div></div>
                            <div></div>
                            <label className={"p-0 m-0  me-1"}>
                              Secondary Contact Cc:{""}
                            </label>
                            <input
                              type={"checkbox"}
                              checked={email.FlagEmailInvoiceCc === "1"}
                              onChange={(e) => {
                                // e true = 1 false = 0
                                setCustomerDetails((prevState) => {
                                  const newState = {
                                    ...prevState,
                                  };
                                  newState.contactemailaddress_data[
                                    index
                                  ].FlagEmailInvoiceCc =
                                    e.target.checked === true ? "1" : "0";
                                  newState.contactemailaddress_data[
                                    index
                                  ].FlagEmailProformaInvoiceCc =
                                    e.target.checked === true && "1";

                                  return newState;
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div>
                          <div>
                            <span className={"fw-bold"}>
                              Proforma Invoicing
                            </span>
                          </div>
                          <div className={"d-flex"}>
                            <div
                              className={
                                "ms-1  d-flex p-2 justify-content-center align-items-center   "
                              }
                            >
                              <label className={"p-0 m-0 me-1"}>
                                Primary Contact To:{""}
                              </label>
                              <input
                                type={"checkbox"}
                                checked={
                                  email.FlagEmailProformaInvoiceTo === "1"
                                }
                                onChange={(e) => {
                                  setCustomerDetails((prevState) => {
                                    const newState = {
                                      ...prevState,
                                    };
                                    newState.contactemailaddress_data[
                                      index
                                    ].FlagEmailProformaInvoiceTo =
                                      e.target.checked === true ? "1" : "0";
                                    return newState;
                                  });
                                }}
                              />
                            </div>
                            <div
                              className={
                                "ms-1   d-flex p-2 justify-content-center align-items-center  "
                              }
                            >
                              <label className={"p-0 m-0  me-1"}>
                                Secondary Contact Cc:
                              </label>
                              <input
                                type={"checkbox"}
                                checked={
                                  email.FlagEmailProformaInvoiceCc === "1"
                                }
                                onChange={(e) => {
                                  // e true = 1 false = 0
                                  setCustomerDetails((prevState) => {
                                    const newState = {
                                      ...prevState,
                                    };
                                    newState.contactemailaddress_data[
                                      index
                                    ].FlagEmailProformaInvoiceCc =
                                      e.target.checked === true ? "1" : "0";
                                    return newState;
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
                <div>
                  <span
                    onClick={() => {
                      handleAddEmailRow();
                    }}
                    className={"ms-2 btn btn-soft-success"}
                  >
                    <i className={" fa-solid fa-plus"}></i> Add Email
                  </span>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={4}>
            <div>
              <div>
                <span className={"h6"}>Phone Number</span>
              </div>
              <div className={"d-flex flex-column w-100"}>
                {customerDetails.contacttelephonenumber_data?.map(
                  (phone, index) => {
                    return (
                      <div key={index} className={"d-flex p-2"}>
                        <input
                          type="text"
                          className={"form-control"}
                          value={phone.TelephoneNumber}
                          onChange={(e) => {
                            setCustomerDetails((prevState) => {
                              const newState = {
                                ...prevState,
                              };
                              newState.contacttelephonenumber_data[
                                index
                              ].TelephoneNumber = e.target.value;

                              return newState;
                            });
                          }}
                        />{" "}
                        {customerDetails.contacttelephonenumber_data.length >
                          1 && (
                          <span
                            onClick={() => {
                              handleRemovePhoneRow(
                                phone.ContactTelephoneNumber_Id
                              );
                            }}
                            className={"ms-1 btn btn-soft-danger"}
                          >
                            <i className={" fa-solid fa-minus"}></i>
                          </span>
                        )}
                      </div>
                    );
                  }
                )}
                <div>
                  <span
                    onClick={() => {
                      handleAddPhoneRow();
                    }}
                    className={"ms-2 btn btn-soft-success"}
                  >
                    <i className={" fa-solid fa-plus"}></i> Add Phone Nr.
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="my-4 text-muted" />
      </div>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            handleCheckEachStep(activeVerticalTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
          Name & Address
        </button>
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={() => {
            handleCheckEachStep(activeVerticalTab + 1);
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          People
        </button>
      </div>
    </div>
  );
}
